import React, { PureComponent } from 'react';
import { Popconfirm } from 'antd';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';

export default class List extends PureComponent {
    getColumns = () => {
        const { showOnMarket ,showMilestone ,approvalTypeList} = this.props;
        const columns = [{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            width: 200,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineName',
            key: 'lineName',
            width: 100,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 140,
        }, {
            title: '项目经理 ',
            dataIndex: 'mainPmName',
            key: 'mainPmName',
            width: 100,
        }, {
            title: 'PML',
            dataIndex: 'pmlName',
            key: 'pmlName',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'invAreaLeaderNameCode',
            key: 'invAreaLeaderNameCode',
            width: 120,
        }, {
            title: '项目类别',
            dataIndex: 'investigationGlobalTypeShow',
            key: 'investigationGlobalTypeShow',
            width: 100,
        }, {
            title: '项目级别',
            dataIndex: 'levelName',
            key: 'levelName',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationTypeName',
            key: 'investigationTypeName',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病分类',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 100,
        }, {
            title: '治疗方式',
            dataIndex: 'treatmentMethodName',
            key: 'treatmentMethodName',
            width: 100,
        }, {
            title: '药物（疗法）分类/主要作用靶点',
            dataIndex: 'drugMainTargets',
            key: 'drugMainTargets',
            width: 100,
        }, {
            title: '研究药物通用名称/产品具体名称/技术名称',
            dataIndex: 'investigationMedicine',
            key: 'investigationMedicine',
            width: 100,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeName',
            key: 'administrationModeName',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'byStageNames',
            key: 'byStageNames',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 100,
        },{
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 120,
        },{
            title: '项目计划开始时间',
            dataIndex: 'investigationPlanBeginTime',
            key: 'investigationPlanBeginTime',
            width: 100,
            render: text => format('date', text),
        },{
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 100,
            render: text => format('date', text),
        },{
            title: '合同额含税/人民币（元）',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
        },{
            title: '津石实际负责中心数量',
            dataIndex: 'siteNum',
            key: 'siteNum',
            width: 100,
        },{
            title: '津石实际随机（入组）数量',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 100,
        },{
            title: 'CDE试验工时登记号',
            dataIndex: 'cdeRegisteNum',
            key: 'cdeRegisteNum',
            width: 100,
        },{
            title: '药品名（中）',
            dataIndex: 'medicineNameCh',
            key: 'medicineNameCh',
            width: 100,
        },{
            title: '药品名（英）',
            dataIndex: 'medicineNameEn',
            key: 'medicineNameEn',
            width: 100,
        },{
            title: '商品名（中）',
            dataIndex: 'commodityNameCh',
            key: 'commodityNameCh',
            width: 100,
        },{
            title: '商品名（英）',
            dataIndex: 'commodityNameEn',
            key: 'commodityNameEn',
            width: 100,
        },{
            title: '上市批准时间（药监局最早发证日期为准）',
            dataIndex: 'marketApprovalTime',
            key: 'marketApprovalTime',
            width: 120,
            render: text => format('date', text),
        },{
            title: '获批类型',
            dataIndex: 'approvalTypeName',
            key: 'approvalTypeName',
            width: 100,
        },{
            title: '获批类型备注',
            dataIndex: 'approvalTypeRemark',
            key: 'approvalTypeRemark',
            width: 100,
        },{
            title: '药监局关键字索引',
            dataIndex: 'medicineKeyWord',
            key: 'medicineKeyWord',
            width: 100,
        },{
            title: '卖点/说明（如有）',
            dataIndex: 'remark',
            key: 'remark',
            width: 100,
        },{
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'right',
            width: 150,
            render: (text, record) => {
                const { showMarketRegiste ,canEditMarketRegiste} = record;
                return (
                    <span>
                        {
                            <span>
                                <a onClick={() => showMilestone(record)}>里程碑登记</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            showMarketRegiste &&
                            <span>
                                {
                                    canEditMarketRegiste?
                                    <a onClick={() => showOnMarket(record)}>上市后登记</a>:
                                    '上市后登记'
                                }
                            </span>
                        }
                    </span>
                );
            }
        }];
        return columns;
    };

    render() {
        const { loading, data, pagination, onChange } = this.props;
        const scrollY = (document.body || document.documentElement).clientHeight - 250;
        return (
            <TableC
                loading={loading}
                columns={this.getColumns()}
                data={data}
                scrollY={scrollY}
                pagination={pagination}
                onChange={onChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ImportantMilestone/components/List.js